export const rankingData = [
  { id: 1, title: '修仙归来当奶爸', author: '唐家白羽', category: '玄幻', status: '连载中', hotIndex: '982万', rank: 1 },
  { id: 2, title: '都市最强赘婿', author: '潇湘夜雨', category: '都市', status: '连载中', hotIndex: '876万', rank: 2 },
  { id: 3, title: '绝世剑神', author: '天蚕土豆丝', category: '仙侠', status: '连载中', hotIndex: '753万', rank: 3 },
  { id: 4, title: '重生之都市仙尊', author: '墨香铜臭', category: '都市', status: '连载中', hotIndex: '698万', rank: 4 },
  { id: 5, title: '万古神帝', author: '风凌天下', category: '玄幻', status: '连载中', hotIndex: '621万', rank: 5 },
];

export const appData = {
  title: '甜柚漫画 APP — 口袋里的漫画图书馆',
  description: '专为手机竖屏打造的下拉式阅读器，支持无限滚动翻页，海量免费全集漫画随时随地畅快阅读。无需横屏、无需翻页按钮，像刷短视频一样轻松看漫画。',
  features: ['竖屏下拉式阅读', '无限滚动连读', '离线缓存下载', '智能推荐算法', '夜间模式护眼', '全本免费畅读'],
  platforms: [
    { name: 'iOS 版', icon: 'ri-apple-fill' },
    { name: 'Android 版', icon: 'ri-android-fill' },
    { name: 'Web 网页版', icon: 'ri-global-line' },
  ],
};

export const aboutData = {
  title: '关于甜柚漫画',
  paragraphs: [
    '甜柚漫画创立于 2024 年，是国内领先的竖屏下拉式漫画阅读平台。我们致力于为漫画爱好者提供极致的手机阅读体验 — 告别传统翻页模式，采用无限滚动技术，手指轻轻下滑即可无缝畅读整部漫画。',
    '平台收录超过 5000 部热门漫画，涵盖玄幻、都市、仙侠、恋爱、悬疑、搞笑等全品类题材，所有作品均为免费全集阅读。每日更新 200+ 章节，热门连载实时同步，绝不让你等更。',
  ],
  stats: [
    { value: '5000+', label: '漫画资源' },
    { value: '200+', label: '日更新章节' },
    { value: '800万+', label: '月活读者' },
    { value: '98%', label: '好评率' },
  ],
};

export const contactData = {
  title: '联系我们',
  description: '无论你是漫画作者、版权方还是热心读者，欢迎通过以下方式与我们联系。投稿、合作、建议，我们都在听。',
  methods: [
    { label: '投稿邮箱', value: 'submit@tianyoumanga.com', icon: 'ri-mail-line' },
    { label: '商务合作', value: 'biz@tianyoumanga.com', icon: 'ri-briefcase-line' },
    { label: '意见反馈', value: 'feedback@tianyoumanga.com', icon: 'ri-feedback-line' },
    { label: '官方微博', value: '@甜柚漫画官方', icon: 'ri-weibo-line' },
  ],
};

export const topicsData = [
  { name: '热门连载', count: 1280, hot: true },
  { name: '新作上线', count: 56, hot: true },
  { name: '完结推荐', count: 890, hot: false },
  { name: '热血战斗', count: 2340, hot: true },
  { name: '恋爱甜宠', count: 1560, hot: true },
  { name: '悬疑推理', count: 720, hot: false },
  { name: '奇幻冒险', count: 1890, hot: true },
  { name: '搞笑日常', count: 1100, hot: false },
  { name: '国漫精选', count: 3200, hot: true },
  { name: '日漫经典', count: 1680, hot: false },
  { name: '本周必追', count: 45, hot: true },
];

export const updatesData = [
  { id: 1, date: '07-28', comic: '修仙归来当奶爸', chapter: '第 286 话 — 血脉觉醒', time: '2 小时前' },
  { id: 2, date: '07-28', comic: '都市最强赘婿', chapter: '第 512 话 — 豪门风云', time: '4 小时前' },
  { id: 3, date: '07-28', comic: '绝世剑神', chapter: '第 198 话 — 剑道巅峰', time: '6 小时前' },
  { id: 4, date: '07-27', comic: '重生之都市仙尊', chapter: '第 345 话 — 仙界归来', time: '昨天' },
  { id: 5, date: '07-27', comic: '万古神帝', chapter: '第 867 话 — 诸神黄昏', time: '昨天' },
  { id: 6, date: '07-27', comic: '逆天邪神传', chapter: '第 156 话 — 九转轮回', time: '昨天' },
  { id: 7, date: '07-26', comic: '全职剑仙', chapter: '第 423 话 — 剑指苍穹', time: '2 天前' },
  { id: 8, date: '07-26', comic: '妖神记', chapter: '第 234 话 — 万妖来朝', time: '2 天前' },
];

export const mediaData = [
  {
    id: 1,
    title: '一分钟了解下拉式阅读',
    duration: '01:28',
    views: '23.5万',
    cover: 'https://readdy.ai/api/search-image?query=A%20warm%20minimalist%20illustration%20of%20a%20person%20holding%20a%20smartphone%20vertically%2C%20displaying%20black%20and%20white%20manga%20panels%20on%20screen%2C%20finger%20scrolling%20down%2C%20cozy%20ambient%20lighting%2C%20soft%20warm%20gradient%20background%20with%20subtle%20speech%20bubble%20motifs%2C%20clean%20modern%20flat%20design%20style%2C%20editorial%20quality&width=800&height=450&seq=media-01&orientation=landscape',
  },
  {
    id: 2,
    title: '无限滚动 vs 传统翻页体验对比',
    duration: '03:15',
    views: '18.2万',
    cover: 'https://readdy.ai/api/search-image?query=A%20side%20by%20side%20comparison%20illustration%20showing%20traditional%20comic%20page%20turning%20versus%20smooth%20vertical%20scroll%20reading%2C%20warm%20atmospheric%20gradient%20background%2C%20clean%20minimalist%20flat%20design%2C%20smartphone%20centered%20with%20comic%20panels%20flowing%20downward%2C%20soft%20ambient%20light%2C%20modern%20tech%20illustration%20style&width=800&height=450&seq=media-02&orientation=landscape',
  },
  {
    id: 3,
    title: '2026 夏季新番导览 — 燃向合集',
    duration: '05:42',
    views: '31.8万',
    cover: 'https://readdy.ai/api/search-image?query=A%20dynamic%20illustration%20of%20multiple%20manga%20covers%20arranged%20in%20a%20collage%2C%20warm%20summer%20vibe%20with%20golden%20and%20coral%20accents%2C%20action%20poses%20silhouettes%2C%20clean%20composition%20on%20a%20warm%20gradient%20background%2C%20editorial%20design%20style%2C%20energetic%20but%20refined%20aesthetic&width=800&height=450&seq=media-03&orientation=landscape',
  },
  {
    id: 4,
    title: '甜柚漫画 APP 使用全攻略',
    duration: '04:06',
    views: '42.3万',
    cover: 'https://readdy.ai/api/search-image?query=A%20warm%20toned%20illustration%20of%20a%20smartphone%20displaying%20a%20manga%20reading%20app%20interface%20with%20vibrant%20comic%20panels%2C%20finger%20tapping%20features%2C%20soft%20coral%20and%20cream%20gradient%20background%2C%20clean%20modern%20flat%20illustration%20style%2C%20guide%20labels%20in%20gentle%20rounded%20design%2C%20approachable%20and%20warm%20aesthetic&width=800&height=450&seq=media-04&orientation=landscape',
  },
];

export const indexData = [
  { id: 1, title: '热血战斗漫画大全', count: 2340, category: '热血' },
  { id: 2, title: '恋爱甜宠专题合集', count: 1560, category: '恋爱' },
  { id: 3, title: '悬疑推理精选推荐', count: 720, category: '悬疑' },
  { id: 4, title: '仙侠修真经典回顾', count: 1890, category: '仙侠' },
  { id: 5, title: '搞笑日常轻松一刻', count: 1100, category: '搞笑' },
  { id: 6, title: '都市言情人气排行', count: 2150, category: '都市' },
  { id: 7, title: '奇幻冒险异世界篇', count: 980, category: '奇幻' },
  { id: 8, title: '校园青春成长物语', count: 1350, category: '校园' },
];

export const faqData = [
  {
    q: '甜柚漫画是免费的吗？需要付费吗？',
    a: '完全免费！甜柚漫画平台上所有漫画均为免费全集阅读，无需任何付费或订阅。我们通过广告合作维持运营，读者可以无限制地畅享海量漫画内容，包括热门连载和经典完结作品。',
  },
  {
    q: '什么是下拉式阅读？和翻页阅读有什么区别？',
    a: '下拉式阅读是甜柚漫画的核心特色。传统漫画阅读需要左右翻页，而我们的下拉式模式让您像刷社交媒体一样 — 手指向下滑动即可连续阅读，无需等待页面加载，体验更加流畅。特别适合手机竖屏场景，单手持机也能轻松畅读。',
  },
  {
    q: '无限滚动功能如何使用？',
    a: '无限滚动功能开启后，当前章节读到底部时，下一章内容会自动加载并无缝衔接，无需手动点击"下一章"。真正做到一口气读完一整部漫画！您可以在阅读设置中自由开启或关闭此功能。',
  },
  {
    q: '支持离线下载吗？',
    a: '支持！甜柚漫画 APP 提供离线缓存功能，您可以在有网络时将喜欢的漫画下载到本地，之后在地铁、飞机等无网络环境中也能畅快阅读。下载的漫画会保存在 APP 内，不占用相册空间。',
  },
  {
    q: '漫画更新频率如何？新章节多久能看？',
    a: '我们每天更新超过 200 个漫画章节，热门连载作品与官方同步更新，通常在源站发布后 1-2 小时内即可在甜柚漫画阅读。您可以在「更新动态」模块查看最新上线的章节列表。',
  },
  {
    q: '如何向平台推荐或投稿漫画？',
    a: '欢迎漫画作者和版权方联系我们！请将作品信息和样章发送至投稿邮箱 submit@tianyoumanga.com，我们的编辑团队会在 3 个工作日内回复。同时也欢迎读者通过意见反馈邮箱推荐您想看的漫画作品。',
  },
];

export const carouselData = [
  {
    id: 1,
    title: '修仙归来当奶爸',
    subtitle: '玄幻神作 · 年度人气 TOP 1',
    description: '仙界至尊渡劫失败，重生为都市单亲爸爸。左手抱娃右手修仙，且看一代仙尊如何在凡间带娃逆袭！',
    tag: '热门连载',
    image: 'https://readdy.ai/api/search-image?query=A%20warm%20toned%20illustration%20of%20a%20modern%20man%20holding%20a%20baby%20with%20one%20arm%20while%20subtle%20magical%20golden%20energy%20flows%20from%20his%20other%20hand%2C%20city%20skyline%20in%20background%2C%20soft%20coral%20and%20cream%20color%20palette%2C%20manga%20cover%20art%20style%2C%20warm%20atmospheric%20lighting%2C%20dynamic%20composition&width=800&height=480&seq=carousel-01&orientation=landscape',
  },
  {
    id: 2,
    title: '绝世剑神',
    subtitle: '仙侠巨制 · 评分 9.6',
    description: '少年持剑入江湖，一剑破万法。从废材弟子到绝世剑神，他的剑道之路注定名震九天十地！',
    tag: '口碑佳作',
    image: 'https://readdy.ai/api/search-image?query=A%20warm%20toned%20illustration%20of%20a%20young%20swordsman%20in%20flowing%20robes%20holding%20a%20glowing%20sword%20standing%20on%20a%20mountain%20peak%2C%20dramatic%20clouds%20and%20mist%2C%20soft%20golden%20and%20coral%20warm%20light%2C%20eastern%20fantasy%20art%20style%2C%20atmospheric%20and%20heroic%20composition&width=800&height=480&seq=carousel-02&orientation=landscape',
  },
  {
    id: 3,
    title: '都市最强赘婿',
    subtitle: '都市爽文 · 阅读量破 10 亿',
    description: '三年隐忍，一朝崛起。当所有人都以为他只是个普通赘婿时，他亮出了真正的底牌 — 这个世界，即将为他颤抖！',
    tag: '人气爆款',
    image: 'https://readdy.ai/api/search-image?query=A%20warm%20toned%20illustration%20of%20a%20confident%20man%20in%20a%20modern%20suit%20standing%20before%20a%20luxury%20skyscraper%2C%20golden%20hour%20lighting%2C%20cityscape%20background%2C%20dramatic%20silhouette%2C%20soft%20coral%20and%20amber%20warm%20tones%2C%20modern%20manga%20cover%20style%2C%20powerful%20and%20elegant%20atmosphere&width=800&height=480&seq=carousel-03&orientation=landscape',
  },
  {
    id: 4,
    title: '重生之都市仙尊',
    subtitle: '逆袭经典 · 收藏突破 500 万',
    description: '一代仙尊重生回高中时代。前世仇敌、今生挚爱，这一世他要改写所有遗憾，重登万界之巅！',
    tag: '编辑力荐',
    image: 'https://readdy.ai/api/search-image?query=A%20warm%20toned%20illustration%20of%20a%20teenager%20with%20determined%20eyes%2C%20school%20uniform%2C%20faint%20magical%20aura%20surrounding%20him%2C%20dual%20worlds%20of%20modern%20classroom%20and%20ancient%20celestial%20realm%20merging%2C%20soft%20coral%20warm%20gradient%2C%20manga%20cover%20art%20style%2C%20emotional%20and%20powerful&width=800&height=480&seq=carousel-04&orientation=landscape',
  },
  {
    id: 5,
    title: '万古神帝',
    subtitle: '玄幻史诗 · 连载 800+ 话',
    description: '诸神陨落的时代，一个少年从微末中崛起。横跨万古岁月，踏遍九天十地，他终将成为那唯一的 — 万古神帝！',
    tag: '长篇巨制',
    image: 'https://readdy.ai/api/search-image?query=A%20warm%20toned%20epic%20illustration%20of%20a%20young%20warrior%20in%20ancient%20armor%2C%20standing%20atop%20a%20floating%20ancient%20temple%2C%20stars%20and%20galaxies%20in%20the%20sky%2C%20massive%20scale%2C%20soft%20golden%20and%20coral%20warm%20lighting%2C%20ancient%20scroll%20and%20rune%20motifs%2C%20epic%20manga%20cover%20art%20style&width=800&height=480&seq=carousel-05&orientation=landscape',
  },
];

export const commentsData = [
  {
    id: 1,
    user: '星海漫游者',
    avatar: 'https://readdy.ai/api/search-image?query=A%20warm%20toned%20minimalist%20portrait%20avatar%20of%20a%20young%20person%2C%20circular%20frame%2C%20soft%20coral%20and%20cream%20background%2C%20simple%20friendly%20illustration%20style%2C%20clean%20flat%20design&width=80&height=80&seq=avatar-01&orientation=squarish',
    comic: '修仙归来当奶爸',
    rating: 5,
    content: '追了半年多了，每次更新都第一时间看！下拉式阅读真的太爽了，一口气能刷十几话，完全停不下来。剧情也越来越精彩，奶爸修仙这个设定太有意思了！',
    date: '2026-07-27',
    likes: 3289,
  },
  {
    id: 2,
    user: '夜雨听风',
    avatar: 'https://readdy.ai/api/search-image?query=A%20warm%20toned%20minimalist%20portrait%20avatar%20of%20a%20person%20with%20glasses%2C%20circular%20frame%2C%20soft%20amber%20and%20cream%20background%2C%20simple%20friendly%20illustration%20style%2C%20clean%20flat%20design&width=80&height=80&seq=avatar-02&orientation=squarish',
    comic: '绝世剑神',
    rating: 5,
    content: '画风太绝了！每一格都可以当壁纸。无限滚动读起来特别流畅，不知不觉就看到了最新章。剑神的世界观也铺得很宏大，期待后续发展！',
    date: '2026-07-26',
    likes: 2156,
  },
  {
    id: 3,
    user: '白日梦想家',
    avatar: 'https://readdy.ai/api/search-image?query=A%20warm%20toned%20minimalist%20portrait%20avatar%20of%20a%20smiling%20person%2C%20circular%20frame%2C%20soft%20warm%20coral%20and%20cream%20background%2C%20simple%20friendly%20illustration%20style%2C%20clean%20flat%20design&width=80&height=80&seq=avatar-03&orientation=squarish',
    comic: '都市最强赘婿',
    rating: 4,
    content: '从第一话追到现在，赘婿逆袭的故事永远不会腻！甜柚漫画的竖屏阅读体验是真的好，坐地铁单手就能看，比那些横屏翻页的舒服太多了。',
    date: '2026-07-25',
    likes: 1872,
  },
];

export const cardsData = [
  {
    id: 1,
    title: '逆天邪神传',
    author: '火星引力',
    category: '仙侠',
    status: '连载中',
    description: '少年得逆天传承，踏上一条无人敢走的修炼之路。邪神之名，威震万界！',
    image: 'https://readdy.ai/api/search-image?query=A%20warm%20toned%20manga%20cover%20illustration%2C%20young%20man%20with%20dark%20energy%20aura%2C%20ancient%20eastern%20fantasy%20theme%2C%20soft%20coral%20and%20cream%20color%20palette%2C%20dramatic%20lighting%2C%20clean%20composition%20on%20warm%20gradient%20background%2C%20vertical%20book%20cover%20style&width=600&height=800&seq=card-01&orientation=portrait',
  },
  {
    id: 2,
    title: '全职剑仙',
    author: '乱世狂刀',
    category: '玄幻',
    status: '连载中',
    description: '网游第一剑客穿越修仙世界，以游戏思维重塑剑道，开创万古未有之剑仙之路。',
    image: 'https://readdy.ai/api/search-image?query=A%20warm%20toned%20manga%20cover%20illustration%2C%20swordsman%20with%20glowing%20sword%20surrounded%20by%20floating%20game%20UI%20elements%2C%20eastern%20fantasy%20style%2C%20soft%20golden%20and%20amber%20color%20palette%2C%20dramatic%20composition%2C%20warm%20atmospheric%20background%2C%20vertical%20book%20cover%20style&width=600&height=800&seq=card-02&orientation=portrait',
  },
  {
    id: 3,
    title: '妖神记',
    author: '妖娆公子',
    category: '奇幻',
    status: '连载中',
    description: '万妖共主陨落千年后转世为人，这一世他要在人妖两界掀起新的风暴！',
    image: 'https://readdy.ai/api/search-image?query=A%20warm%20toned%20manga%20cover%20illustration%2C%20mysterious%20figure%20with%20fox%20spirit%20and%20cherry%20blossom%20elements%2C%20eastern%20fantasy%20theme%2C%20soft%20coral%20and%20warm%20cream%20color%20palette%2C%20ethereal%20atmosphere%2C%20vertical%20book%20cover%20style%2C%20clean%20composition&width=600&height=800&seq=card-03&orientation=portrait',
  },
  {
    id: 4,
    title: '都市灵异事件簿',
    author: '夜不语',
    category: '悬疑',
    status: '连载中',
    description: '普通大学生意外获得阴阳眼，从此卷入都市中那些不为人知的灵异事件。',
    image: 'https://readdy.ai/api/search-image?query=A%20warm%20toned%20manga%20cover%20illustration%2C%20modern%20city%20at%20night%20with%20mysterious%20shadow%20figure%2C%20subtle%20supernatural%20elements%2C%20soft%20amber%20and%20warm%20cream%20color%20palette%2C%20suspenseful%20atmosphere%2C%20vertical%20book%20cover%20style%2C%20clean%20composition&width=600&height=800&seq=card-04&orientation=portrait',
  },
  {
    id: 5,
    title: '甜心小厨娘',
    author: '糖炒栗子',
    category: '恋爱',
    status: '连载中',
    description: '米其林三星女主厨穿越到古代，用现代美食技艺征服傲娇王爷的胃和心。',
    image: 'https://readdy.ai/api/search-image?query=A%20warm%20toned%20manga%20cover%20illustration%2C%20cheerful%20girl%20in%20ancient%20Chinese%20dress%20holding%20steaming%20food%2C%20romantic%20vibe%2C%20soft%20coral%20and%20cream%20color%20palette%2C%20sweet%20atmosphere%2C%20vertical%20book%20cover%20style%2C%20clean%20composition&width=600&height=800&seq=card-05&orientation=portrait',
  },
  {
    id: 6,
    title: '电竞之王',
    author: '指尖流年',
    category: '竞技',
    status: '完结',
    description: '退役电竞选手重返赛场，带领新战队从网吧赛一路杀到世界总决赛。',
    image: 'https://readdy.ai/api/search-image?query=A%20warm%20toned%20manga%20cover%20illustration%2C%20young%20gamer%20with%20headset%20and%20determined%20expression%2C%20esports%20arena%20background%2C%20soft%20golden%20and%20amber%20color%20palette%2C%20dynamic%20lighting%2C%20vertical%20book%20cover%20style%2C%20clean%20composition&width=600&height=800&seq=card-06&orientation=portrait',
  },
  {
    id: 7,
    title: '末日生存指南',
    author: '末世行者',
    category: '科幻',
    status: '连载中',
    description: '末日降临，丧尸横行。一个普通上班族如何在绝境中带领幸存者建立新文明？',
    image: 'https://readdy.ai/api/search-image?query=A%20warm%20toned%20manga%20cover%20illustration%2C%20survivor%20in%20post%20apocalyptic%20city%20ruins%2C%20dramatic%20sunset%20lighting%2C%20soft%20coral%20and%20warm%20cream%20color%20palette%2C%20atmospheric%20composition%2C%20vertical%20book%20cover%20style%2C%20clean%20design&width=600&height=800&seq=card-07&orientation=portrait',
  },
];

export const featuresData = [
  {
    id: 1,
    icon: 'ri-scroll-to-bottom-line',
    title: '下拉式阅读',
    description: '颠覆传统翻页模式，手指下滑即可连续阅读。像刷短视频一样流畅，单手操作轻松惬意，阅读节奏由你掌控。',
  },
  {
    id: 2,
    icon: 'ri-loop-left-line',
    title: '无限滚动',
    description: '一章读完自动衔接下一章，告别频繁点击"下一章"的烦恼。沉浸式阅读体验，让精彩剧情不停歇。',
  },
  {
    id: 3,
    icon: 'ri-smartphone-line',
    title: '免费全集',
    description: '5000+ 漫画全本免费畅读，无需付费订阅。热门连载实时同步更新，完本经典随时重温，漫画自由触手可及。',
  },
  {
    id: 4,
    icon: 'ri-device-line',
    title: '手机优化',
    description: '专为竖屏手机阅读优化，自适应屏幕尺寸。夜间模式护眼，离线缓存省流，随时随地享受极致阅读体验。',
  },
];